import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ProfessionForm from './ProfessionForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditProfessionModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.updateProfession( values.id, { title: values.title } )
        .then( ( profession ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( profession );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteProfession = () => {
        this.setState( { fetching: true } );
        this.props.deleteProfession( this.props.profession.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }



    render() {
        const { profession } = this.props;
        return (
            <DLModal title='Edit Profession'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ProfessionForm next={ this.submitHandler } initialValues={ profession } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS PROFESSION?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteProfession }>
                            DELETE PROFESSION
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS PROFESSION
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateProfession: ( id, data ) => {
            return dAPI.patch( `/admin/professions/${ id }`, data );

        },
        deleteProfession: ( id ) => {
            return dAPI.delete( `/admin/professions/${ id }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( EditProfessionModal );
